/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApproveManagerRequestNotificationActionData
 */
export interface ApproveManagerRequestNotificationActionData {
    /**
     * 
     * @type {string}
     * @memberof ApproveManagerRequestNotificationActionData
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof ApproveManagerRequestNotificationActionData
     */
    granteeUserId: string;
    /**
     * 
     * @type {string}
     * @memberof ApproveManagerRequestNotificationActionData
     */
    granteeAddress: string;
}

/**
 * Check if a given object implements the ApproveManagerRequestNotificationActionData interface.
 */
export function instanceOfApproveManagerRequestNotificationActionData(value: object): value is ApproveManagerRequestNotificationActionData {
    let isInstance = true;
    isInstance = isInstance && "userId" in value && value["userId"] !== undefined;
    isInstance = isInstance && "granteeUserId" in value && value["granteeUserId"] !== undefined;
    isInstance = isInstance && "granteeAddress" in value && value["granteeAddress"] !== undefined;

    return isInstance;
}

export function ApproveManagerRequestNotificationActionDataFromJSON(json: any): ApproveManagerRequestNotificationActionData {
    return ApproveManagerRequestNotificationActionDataFromJSONTyped(json, false);
}

export function ApproveManagerRequestNotificationActionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApproveManagerRequestNotificationActionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
        'granteeUserId': json['grantee_user_id'],
        'granteeAddress': json['grantee_address'],
    };
}

export function ApproveManagerRequestNotificationActionDataToJSON(value?: ApproveManagerRequestNotificationActionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_id': value.userId,
        'grantee_user_id': value.granteeUserId,
        'grantee_address': value.granteeAddress,
    };
}

